import { SummaryField } from '../summary/summaryApi';
import { buildSheetRows, safeFileName, sheetColumns } from '../summary/summaryExport';
import { DirectorPharmacy } from './directorApi';

const SHEET_NAME_MAX = 31;
const BLANK_CELL = '';

/** Имя листа Excel: до 31 символа, без символов \ / ? * [ ] : */
function safeSheetName(text: string): string {
  return text.replace(/[\\/?*[\]:]+/g, '_').slice(0, SHEET_NAME_MAX);
}

/** Номер аптеки в имени файла и листа: 9990/1 -> 9990_1 */
function pharmacyKey(pharmacy: DirectorPharmacy): string {
  return safeFileName(String(pharmacy.pharmacyNum));
}

/** Excel по одной аптеке: заголовки, строки месяца и итоги */
export async function exportPharmacyExcel(
  fields: SummaryField[],
  pharmacy: DirectorPharmacy,
  month: string
): Promise<void> {
  // Библиотека тяжелая: подгружается только при выгрузке, а не при открытии вкладки
  const XLSX = await import('xlsx');
  const key = pharmacyKey(pharmacy);

  const worksheet = XLSX.utils.aoa_to_sheet(buildSheetRows(fields, pharmacy.rows, pharmacy.totals));
  worksheet['!cols'] = sheetColumns(fields);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, safeSheetName(`Pharmacy_${key}`));
  XLSX.writeFile(workbook, safeFileName(`Pharmacy_${key}_${month}.xlsx`));
}

/**
 * Общий Excel: один лист, у каждой аптеки заголовок «Аптека №...», строки месяца, «Итого:» и пустая строка.
 * Названия колонок - одной строкой сверху.
 */
export async function exportAllExcel(
  fields: SummaryField[],
  pharmacies: DirectorPharmacy[],
  month: string
): Promise<void> {
  const XLSX = await import('xlsx');

  const sheetRows: (string | number | null)[][] = [fields.map((f) => f.label)];
  pharmacies.forEach((pharmacy) => {
    const title: (string | number | null)[] = fields.map(() => BLANK_CELL);
    title[0] = `Аптека №${pharmacy.pharmacyNum}`;
    sheetRows.push(title);

    // Первая строка листа аптеки - заголовки, они уже есть сверху
    buildSheetRows(fields, pharmacy.rows, pharmacy.totals).slice(1).forEach((row) => sheetRows.push(row));
    sheetRows.push([]);
  });

  const worksheet = XLSX.utils.aoa_to_sheet(sheetRows);
  worksheet['!cols'] = sheetColumns(fields);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, safeSheetName(`All_Pharmacies_${month}`));
  XLSX.writeFile(workbook, safeFileName(`All_Pharmacies_${month}.xlsx`));
}
